import { render, staticRenderFns } from "./CompletednonConfirmedAppointments.vue?vue&type=template&id=2158a722&"
import script from "./CompletednonConfirmedAppointments.vue?vue&type=script&lang=js&"
export * from "./CompletednonConfirmedAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports